import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import projectReducer from './projectSlice';
import userReducer from './userSlice';
import organizationReducer from './organizationSlice';

export const store = configureStore({
  reducer: {
    projects: projectReducer,
    user: userReducer,
    organization: organizationReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Define the AppThunk type for async actions
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
